import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';

const states: Ng1StateDeclaration[] = [
    {
        name: 'printDashboard',
        url: '/printDashboard/:guid/:beginDate/:endDate/:groupGuid?',
        component: 'wtPrintDashboardState',
        abstract: false,
        resolve: {
            printing: () => false,
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve
        },
        params: {
            groupGuid: null
        },
        data: {
            backButtonDisabled: () => false,
            backButtonVisibility: () => true,
            displayName: 'Print preview',
            editButtonDisabled: () => true,
            editButtonVisibility: () => true,
            icon: 'fa-print',
            visible: false,
        }
    }];

export default states;